<template>
  <div class="contact-btn__back">
    <router-link
      :id="stepTagId"
      class="contact-btn__back--btn"
      :to="stepPath"
      v-if="$route.meta.order > 1"
    >
      <i class="atlas-glyphs-m-arrow-left"></i>戻る
    </router-link>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const route = useRoute();

const stepPath = computed(() => {
  const nextStepNumber = route.meta.order - 1;
  return { path: `/step${nextStepNumber}`, query: route.query };
});
const stepTagId = computed(() => {
  return `back${route.meta.order}_slide`;
});
</script>